export const sunlightMileStoneName = (mileStoneId: number) => {
    switch (mileStoneId) {
        case 0:
            return "M0 - Notice to proceed";
        case 1:
            return "M1 - Installation";
        case 2:
            return "M2 - Permission to operate";
    }
}